import React from 'react'

import Country from './Country'
import { useStateValue } from './StateProvider'

const Layer = () => {
    const [{ selected }] = useStateValue()

    return (
        <div className='layer'>
            {selected !== null && <Country />}
        </div>
    )
}

export default Layer